export function parseFullName(firstName, insertion, lastName) {
  return [
    firstName,
    insertion,
    lastName,
  ]
    .filter((namePart) => namePart)
    .join(' ');
}